// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* For mobile view */
@media (max-width: 768px) {
  .sider {
    display: none; /* Hide sidebar on mobile by default */
  }

  .show-mobile-menu {
    display: block !important; /* Show sidebar when toggle is active */
    z-index: 1001; /* Ensure it overlays the content */
    position: fixed;
    width: 250px;
  }

  .mobile-menu-toggle {
    position: fixed;
    top: 20px;
    left: 20px;
    z-index: 1001; /* Ensure the button is above other content */
  }
}

.sider .ant-menu-dark .ant-menu-item,
.sider .ant-menu-dark .ant-menu-submenu-title {
  color: rgb(240, 240, 240) !important;
}

.sider .ant-menu-dark .ant-menu-item:hover,
.sider .ant-menu-dark .ant-menu-submenu-title:hover {
  color: #000000 !important; /* Darken on hover if needed */
}

.sider .ant-menu-dark .ant-menu-item-selected {
  background-color: #d9d9d9; /* Light background on selection */
  color: black !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/SideBar/SideBar.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE;IACE,aAAa,EAAE,sCAAsC;EACvD;;EAEA;IACE,yBAAyB,EAAE,uCAAuC;IAClE,aAAa,EAAE,mCAAmC;IAClD,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,SAAS;IACT,UAAU;IACV,aAAa,EAAE,6CAA6C;EAC9D;AACF;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,yBAAyB,EAAE,8BAA8B;AAC3D;;AAEA;EACE,yBAAyB,EAAE,kCAAkC;EAC7D,uBAAuB;AACzB","sourcesContent":["/* For mobile view */\n@media (max-width: 768px) {\n  .sider {\n    display: none; /* Hide sidebar on mobile by default */\n  }\n\n  .show-mobile-menu {\n    display: block !important; /* Show sidebar when toggle is active */\n    z-index: 1001; /* Ensure it overlays the content */\n    position: fixed;\n    width: 250px;\n  }\n\n  .mobile-menu-toggle {\n    position: fixed;\n    top: 20px;\n    left: 20px;\n    z-index: 1001; /* Ensure the button is above other content */\n  }\n}\n\n.sider .ant-menu-dark .ant-menu-item,\n.sider .ant-menu-dark .ant-menu-submenu-title {\n  color: rgb(240, 240, 240) !important;\n}\n\n.sider .ant-menu-dark .ant-menu-item:hover,\n.sider .ant-menu-dark .ant-menu-submenu-title:hover {\n  color: #000000 !important; /* Darken on hover if needed */\n}\n\n.sider .ant-menu-dark .ant-menu-item-selected {\n  background-color: #d9d9d9; /* Light background on selection */\n  color: black !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
